// ─── teamChatUiState ─────────────────────────────────────────────────────────
//
// A tiny, client-only shared flag for "is the Team Chat floater open right
// now?". The floater (TeamChatFloater) owns its open/closed UI state in React
// and mirrors it here; the always-mounted notifier (useTeamChatNotifications)
// reads it to decide whether a new message warrants a toast/chime. This avoids
// the old, brittle `pathname === '/team-chat'` check now that the chat is a
// floating popup that can be open on ANY route.
//
// Also exposes openTeamChat() — a fire-and-forget way for any surface (e.g. the
// sidebar nav item, a future deep link) to pop the bubble open without
// importing the component. It dispatches a window CustomEvent the floater
// listens for.
//
// Everything guards `typeof window` so importing this in an SSR/test context
// can't throw.

const OPEN_EVENT = 'planos:open-team-chat'

// Module-level mirror of the floater's open state. Defaults to closed.
let _open = false

/** True while the Team Chat floater panel is expanded/visible. */
export function isTeamChatOpen() {
  return _open
}

/** Mirror the floater's open/closed state here so the notifier can read it. */
export function setTeamChatOpen(open) {
  _open = !!open
}

/**
 * Ask the floater to open + focus. Safe to call from anywhere; if the floater
 * isn't mounted yet the event is simply unheard (no throw).
 */
export function openTeamChat() {
  if (typeof window === 'undefined') return
  try {
    window.dispatchEvent(new Event(OPEN_EVENT))
  } catch {
    // No window / dispatch unavailable (SSR, locked-down embed) — no-op.
  }
}

// Exported so the floater can subscribe to the same channel openTeamChat()
// publishes on, without the string drifting between the two files.
export const TEAM_CHAT_OPEN_EVENT = OPEN_EVENT
